import React, { useCallback, useEffect, useRef, useState } from 'react';
import './members.scss';
import { useLocation } from 'react-router-dom';

import service from '../../data/members.js';
import GlobalParams from '../../helpers/GlobalParams.js';
import parameters from '../../data/data.js';
import notify from 'devextreme/ui/notify';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import Form, { Item, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions } from 'devextreme-react/form';
import { Button, Lookup, TextBox, LoadPanel, Popup, Menu, NumberBox } from 'devextreme-react';
//import validationRules from 'path/to/validationRules';

import ApiHelper from '../../helpers/ApiHelper';
import NewMember from '../NewMember/NewMember.js';
import NewClaim from '../NewClaim/NewClaim.js';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';
import ReportView from '../ReportView/ReportView.js';
import UploadMembers from '../UploadMembers/UploadMembers.js';
import MemberDependant from '../MemberDependant/MemberDependant.js';
import axios from 'axios';
import ChangesRequests from '../ChangesRequests/ChangesRequests.js';
import Supplimentary from '../Supplimentary/Supplimentary.js';
import PayOff from '../PayOff/PayOff.js';
import LoanTopUp from '../LoanTopUp/LoanTopUp.js';
import { PageSize } from 'devextreme-react/cjs/diagram.js';


const isDateInRange = (date_from, date_to, check_date) => {
  return check_date >= date_from && check_date <= date_to;
}

// var defaultSchemeId = null;
// if(GlobalParams.schemeStore.length > 0){
//   defaultSchemeId = GlobalParams.schemeStore[0]["schemeID"];
//   console.log(defaultSchemeId);
// }

function Members() {

  const [cachedData, setCachedData] = useState(() => {
    // Check if there's any saved data in localStorage when the component mounts
    const savedData = localStorage.getItem('myPageData');
    return savedData ? JSON.parse(savedData) : null;
  });

  const [isGlicoWelfare, setIsGlicoWelfare] = useState(false);
  const [IsPopFund, setIsPopFund] = useState(false);
  const [IsPen, setIsPen] = useState(false);
  const [vsPOPFundMemberSearch, setVsPOPFundMemberSearch] = React.useState(false);
  const [vsMainMemberSearch, setVsMainMemberSearch] = React.useState(false);
  const [vsMainGridMembers, setVsMainGridMembers] = React.useState(false);

  const [rdSchemeId, setRdSchemeId] = useState(false);
  const [searchMask, setSearchMask] = useState(null);
  const [searchMaskRules, setSearchMaskRules] = useState(null);

  const [lblSearchCriteria, setLblSearchCriteria] = useState('Staff No');
  const [isLoanTop, setIsLoanTop] = useState(false);
  const [isLoanTermExt, setIsLoanTermExt] = useState(false);
  const [isCreditLife, setIsCreditLife] = useState(false);
  const [fixed_benefit, set_fixed_benefit] = useState(true);
  const [vsCreditLifeBtns, setVsCreditLifeBtns] = useState(false);
  const [vsGroupLifeBtns, setVsGroupLifeBtns] = useState(false);
  const [btnsWidth, setBtnsWidth] = useState(350);
  const [lblheader, setLblHeader] = useState('');
  const [vsMemberGrid, setVsMemberGrid] = useState(false);
  const [popupRptSrchVisible, setPopupRptSrchVisible] = useState(false);
  const [AccountYearStore, setAccountYearStore] = useState(GlobalParams.AccountYears);
  const [periodStore, setPeriodStore] = useState([]);
  //const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  //const [report_name, setreport_name] = React.useState('');
  const [rpt_name, setRpt_name] = useState('');
  const [rptUrl, setRptUrl] = useState('');

  const hideRptSrchButtonClick = () => {
    setPopupRptSrchVisible(false);
  }

  const doFetchRpt = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if(isGlicoWelfare){
      console.log("print welfare statement");
      fetchRpt(
        {
          "reference": schemeID,
          "settings": "15",
          "SchemeID": schemeID,
          "fund_year": periodStore.AccountYear
        }
      );
    }else{
      fetchRpt(
        {
          "reference": member_name,
          "settings": "13",
          "MemberId": member_id,
          "SchemeID": schemeID,
          "FundYear": periodStore.AccountYear
        }
      );
    }
  }, [periodStore]);

  const dataGridOptions = {
    allowUpdating: false,
    mode: 'form',
    allowAdding: false,
    allowDeleting: false,
  };

  const dpGridOptions = {
    allowUpdating: false,
    mode: 'form',
    allowAdding: false,
    allowDeleting: false,
  };

  //props.location.state && 
  const location = useLocation();
  const receivedData = "";//location.state.data;{ text: 'Request New Claim', icon: 'edit' },

  const [vsIsPen, setVsIsPen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const containerRef = useRef(null);
  const renderPdfViewer = (base64PDF) => {
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };

  const [vsMedicalsAwaiting, setVsMedicalsAwaiting] = React.useState(false);
  const [vsMedicalsReceived, setVsMedicalsReceived] = React.useState(false);
  const [vsMovement, setVsMovement] = React.useState(true);
  const [schemeID, setSchemeID] = React.useState(null);

  //var membersData = service.getMembersStore();
  var searchPanelOptions = {
    visible: true,
    width: 250
  };
  var schemeIDOptions = {
    dataSource: GlobalParams.schemeStore, valueExpr: 'schemeID', displayExpr: 'SchemeDescription'
  }
  var groupOptions = {
    contextMenuEnabled: true, groupPanel: { visible: true },
  }
  var scrollingOptions = { mode: 'standard' }
  var pagingOptions = { enabled: true, PageSize: 20 }

  const [membersData, setData] = useState(null);

  const fetchData = async (scheme_id, name) => {
    try {
      // if (searchMask === 'GPS X00000') {
      //   name = "GPS" + name;

      // }
      let url = GlobalParams.ApiUrlPrefix + "search-members?scheme_id=" + scheme_id + "&name=" + name;
      if (isCreditLife) {
        url = GlobalParams.ApiUrlPrefix + "search-credit-life-members?scheme_id=" + scheme_id + "&name=" + name;
      }
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );

      let isLoggedIn = (localStorage.getItem('isLoggedIn') === '1');
      if (!isLoggedIn) {
        setVsMainGridMembers(true);
        setVsIsPen(true);
      }
      setVsViewMember(true);
      setVsMovement(true);
      default_grid_columns();
      setData(result.data);
    } catch (error) {
      setIsLoading(false);
      setData([]);
      notify("No members found", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
      handleCancelMovementButtonClick();
    }
  };

  const checkIfPen = () => {
    var SchemeDetails = GlobalParams.schemeStore.find(item => item.pen === "1");
    if (SchemeDetails !== undefined && SchemeDetails.pen === "1") {
      setVsIsPen(true);
    } else {
      setVsIsPen(false);
    }
  }

  const fetchDataAll = async (scheme_id) => {
    try {
      let url = GlobalParams.ApiUrlPrefix + "getMembersPerScheme?scheme_id=" + scheme_id;
      if (isCreditLife) {
        //url = GlobalParams.ApiUrlPrefix + "search-credit-life-members?scheme_id=" + scheme_id;
      }
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );


      //if its pen, then set
      checkIfPen();

      setVsViewMember(true);
      setVsMovement(true);
      default_grid_columns();
      GlobalParams.membersData = result.data;
      setData(result.data);
      //setCachedData(result.data);
    } catch (error) {
      setIsLoading(false);
      setData([]);
      notify("No members found", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
      handleCancelMovementButtonClick();
    }
  };

  const fetchExtraPremium = async (scheme_id, member_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-members-xtraP-debit-notes?scheme_id=" + scheme_id + "&member_id=" + member_id,
        GlobalParams.bearerToken
      );
      let debits_length = 0;
      if (result.data.length > 0) {
        debits_length = result.data.length - 1;
      }
      setIsLoading(true);

      setreport_name('Print Cover Certificate');
      //setPopupReportVisible(true);
      setIsLoading(true);

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=002&referenceNumber=' + result.data[debits_length].reference + '&email=' +
        GlobalParams.UserEmail;

      fetchRpt(url);

    } catch (error) {
      setIsLoading(false);
      notify("No extra premium debit notes found for the client", 'error', 5000);
    }
  };

  const default_grid_columns = () => {
    setVsMovement(true);
    setVsMedicalsAwaiting(false);
    setVsMedicalsReceived(false);
  }

  const fetchMedicalsData = async (scheme_id, medical_type) => {
    try {
      //?scheme_id=" + scheme_id
      let url = GlobalParams.ApiUrlPrefix + "members-going-for-medicals";
      if (medical_type === '2') {
        url = GlobalParams.ApiUrlPrefix + "members-who-have-done-medicals";
      }
      /*const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );*/
      const result = await ApiPostHelper.postData(
        url,
        GlobalParams.bearerToken,
        JSON.stringify({ 'scheme_id': scheme_id })
      );


      //if (result.status === 200) {
      setVsViewMember(true);
      setData(result.data);

      setVsMovement(false);
      if (medical_type === "1") {
        setVsMedicalsAwaiting(true);
        setVsMedicalsReceived(false);
      } else if (medical_type === "2") {
        setVsMedicalsAwaiting(false);
        setVsMedicalsReceived(true);
      }
      setIsLoading(false);
      handleCancelMedicalsButtonClick();
      if (result.data.length === 0) {
        notify(result.message, 'error', 5000);
      }
      //}
    } catch (error) {
      setIsLoading(false);
      notify(error.response.data.message, 'error', 5000);
    }
  };



  const validationRules = {
    scheme_id: [{ type: 'required', message: 'Scheme is required.' }],
    name: [{ type: 'required', message: 'Name is required.' }],
  };

  //////search form//////
  const [searchStore, setSearchStore] = useState({
    scheme_id: GlobalParams.defaultSchemeId,
    name: '',
  });

  const [searchMedicalsStore, setSearchMedicalStore] = useState({
    scheme_id: null,
    medical_type: '',
  });

  const validateForm = (e) => {
    // Implement your validation logic here
    //console.log('Form content is ready:', e);
  };

  const onProductValueChanged = (e) => {

    //find out if the product is creditlife or grouplife


    setSchemeID(e.value);
    setSearchStore({ ...searchStore, scheme_id: e.value });
  };

  const onNameValueChanged = (e) => {
    setSearchStore({ ...searchStore, name: e.value });
  };

  const doSearch = useCallback(async (e) => {
    e.preventDefault();
    //TODO perform the search here
    setIsLoading(true);
    fetchData(searchStore.scheme_id, searchStore.name);
  }, [searchStore]);

  const doSearchAll = useCallback(async (e) => {
    e.preventDefault();
    //TODO perform the search here
    setIsLoading(true);
    fetchDataAll(searchStore.scheme_id);
  }, [searchStore]);
  /////end of search form///

  const doMedicalSearch = useCallback(async (e) => {
    e.preventDefault();
    default_grid_columns();
    if (searchMedicalsStore.medical_type === '3') {
      setIsLoading(true);

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=016&referenceNumber=' + searchMedicalsStore.scheme_id + '&email=' +
        GlobalParams.UserEmail;

      fetchRpt(url);
    } else {
      //TODO perform the search here
      setIsLoading(true);
      fetchMedicalsData(searchMedicalsStore.scheme_id, searchMedicalsStore.medical_type);
    }
  }, [vsMovement, vsMedicalsAwaiting, vsMedicalsReceived]);

  const navigateToClaim = () => {

  }

  /////////popup functions//////
  const [popupVisible, setPopupVisible] = useState(false);

  const showPopup = () => {
    let tmpSchemeStore = [];
    if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
      tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
    }
    if (tmpSchemeStore.length > 0) {
      setSchemeStore(filterSchemes("0"));
      defaultBtnOptions();
      setBtnAddMember('danger');
      setVsMemberGrid(false);
      setPopUpMemberTitle('Add New Member');
      setPopupVisible(true);
    } else {
      notify(`You don't have an active scheme to Add a member to`, 'error', 5000);
    }
  };

  const hidePopup = () => {
    setPopupVisible(false);
  };
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };
  ////////end of popup functions//

  //credit life pop ups.....
  const [popupSuppVisible, setPopupSuppVisible] = useState();
  const [popupPayOffVisible, setPopupPayOffVisible] = useState();
  const [popupLoanTopUpVisible, setPopupLoanTopUpVisible] = useState();

  const hideSuppPopup = () => {
    setPopupSuppVisible(false);
  }
  const hideLoanTopUpPopup = () => {
    setPopupLoanTopUpVisible(false);
  }
  const hidePayOffPopup = () => {
    setPopupPayOffVisible(false);
  }
  //end of credit life ups...

  ///////claim popup functions//
  const [popupClaimVisible, setPopupClaimVisible] = useState(false);

  const showClaimPopup = () => {
    setPopupClaimVisible(true);
  };

  const hideClaimPopup = () => {
    //notify("Claim Request Successfully Submite", 'success', 4000);
    setPopupClaimVisible(false);
  };
  /////////end of claim popup functions//
  const [schemeStore, setSchemeStore] = useState(GlobalParams.schemeStore);//.filter(scheme => (scheme.StatusCode === "001")));
  const [member_name, setMemberName] = React.useState('');
  const [member_no, setMemberNo] = React.useState('');
  const [member_id, setMemberId] = React.useState('');
  const [previousSalary, setPreviousSalary] = React.useState('');
  const [previousMonthlySalary, setPreviousMonthlySalary] = React.useState('');
  const [popUpMemberTitle, setPopUpMemberTitle] = React.useState('');
  const [isVsViewMember, setVsViewMember] = React.useState(false);
  const [loanNo, setLoanNo] = React.useState('');
  const [currentLoanAmount, setCurrentLoanAmount] = React.useState('');
  const [currentLoanTerm, setCurrentLoanTerm] = useState('');
  const [tenor, setTenor] = React.useState('');
  const [interestRate, setInterestRate] = React.useState('');

  var defaultSalaryStore = {
    portal_user_id: GlobalParams.ContactPersonId,
    CurrentSalary: previousMonthlySalary,
    scheme_id: null,
    endorsement_type: null,
    effective_date: null,
    policy_member_id: null,
    MemberSalary: null,
    requested_change: '',
    Salary: null
  }
  const [memberStore, setEndorseMember] = React.useState(defaultSalaryStore);
  const [vsAddDependants, setVsAddDependants] = React.useState(false);

  //for credit life....
  var defaultloanTopStore = {
    portal_user_id: GlobalParams.ContactPersonId,
    scheme_id: '',
    endorsement_type: '',
    new_loan_amount: '',
    effective_date: null
  }
  const [loanTopUpStore, setLoanTopStore] = React.useState(defaultloanTopStore);


  const fetchDp = async (scheme_id, member_id, member_no, view_type) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-dependants-on-member?member_id=" + member_id,
        GlobalParams.bearerToken
      );
      //result.data;
      setIsLoading(false);
      let tmp_DependantsData = result.data.map(dependant => {
        return {
          ...dependant,
          DependantFullName: dependant.Name,
          DependantDOB: dependant.dob,
          RelationshipType: dependant.Relation,
          DependantJoiningDate: dependant.dob,
          DependantNo: dependant.DependantNo
        };
      });


      setDependantsData(tmp_DependantsData);


      setPopupDependantsVisible(true);
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsLoading(false);
      setDependantsData([]);
      setPopupDependantsVisible(true);
      console.log(error);

      //notify(error.response.data.message,5000);
    } finally {
      if (view_type === 1) {
        setVsAddDependants(true);
      } else {
        setVsAddDependants(false);
      }
    }
  };

  const postDependants = async (scheme_id, member_id, endorsement_type) => {
    try {
      let tmp_dependantsData = dependantsData || [];

      let post_data = {
        'portal_user_id': GlobalParams.ContactPersonId,
        'scheme_id': scheme_id,
        'endorsement_type': endorsement_type,
        'effective_date': new Date(),
        'requested_change': 'New Dependent Joining',
        'policy_member_id': member_id
      };

      let combinedHashmap = tmp_dependantsData.length > 0 ? tmp_dependantsData.reduce((acc, obj, index) => {
        // Check if DependantNo is null, undefined, or empty
        if (!obj.DependantNo) {
          // Build the hash map only if DependantNo is null, undefined, or empty
          Object.keys(obj).forEach(key => {
            acc[`dependants[${index}][${key}]`] = obj[key];
          });
        }
        return acc;
      }, { ...post_data }) : post_data;



      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "request-endorsements",
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setIsLoading(false);
      postAutomate(result.data.data.request_id, post_data.scheme_id);
      notify(result.data.message, 'success', 5000);
      handleDependantsButtonClick();
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  useEffect(() => {

    let isLoggedIn = (localStorage.getItem('isLoggedIn') === '1');
    if (!isLoggedIn) {
      //display the member popup
      setVsMainMemberSearch(false);
      setVsMainGridMembers(false);
      setVsPOPFundMemberSearch(true);
    } else {
      if (GlobalParams.IsClientLoggedIn) {
        setVsMainMemberSearch(false);
        setVsMainGridMembers(true);
        setVsPOPFundMemberSearch(true);
      } else {
        setVsMainMemberSearch(true);
        setVsMainGridMembers(true);
        setVsPOPFundMemberSearch(false);
      }
      if (cachedData) {
        localStorage.setItem('myPageData', JSON.stringify(cachedData));
      } else {
        //if is client login, then load all members
        if (GlobalParams.IsClientLoggedIn) {
          checkIfPen();
          //if (GlobalParams.membersData.length === 0) {
          var SchemeDetails = GlobalParams.schemeStore.find(item => item.pen === "1");
          if (SchemeDetails !== undefined && SchemeDetails.pen === "1") {
            if (GlobalParams.PopFundAccessLevelId === "2") {
              setIsLoading(true);
              if (GlobalParams.schemeStore.lenghth > 0) {
                fetchDataAll(GlobalParams.schemeStore[0]["schemeID"]);
              }
            }
            if (GlobalParams.schemeStore.length > 0) {
              setRdSchemeId(true);
              setSearchMask('GPS X00000');
              setSearchMaskRules('X: /[02-9]/');
              setSearchStore({ ...searchStore, scheme_id: GlobalParams.schemeStore[0]["schemeID"] });
            }
          } else {
            if (GlobalParams.schemeStore.length > 0) {
              fetchDataAll(GlobalParams.schemeStore[0]["schemeID"]);
            }
          }
        }
      }


      //iterate and determine if vsCreditLifeBtns or vsGroupLifeBtns
      var SchemeDetails = GlobalParams.schemeStore.find(item => item.IsCreditLifeCover === "1");
      if (SchemeDetails !== undefined && SchemeDetails.IsCreditLifeCover === "1") {
        setVsCreditLifeBtns(true);
      }
      SchemeDetails = GlobalParams.schemeStore.find(item => item.IsCreditLifeCover === "0");
      if (SchemeDetails !== undefined && SchemeDetails.IsCreditLifeCover === "0") {
        setVsGroupLifeBtns(true);
        if (SchemeDetails !== undefined && SchemeDetails.fixed_benefit === "0") {
          set_fixed_benefit(false);
        }
      }

      //SchemeDetails = GlobalParams.schemeStore.find(item => item.fixed_benefit === "1");

      //GlobalParams.PopFundAccessLevelId
      //schemeStore is > 1 display the search 
      //else if its == 1 
      //then, if its secretariat display all... else display view Member button...


    }

  }, [memberStore, cachedData]);

  const onMenuItemClick = (cellInfo, item) => {
    if (item === 'Statement of Account') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);

      setPopupRptSrchVisible(true);

      //setIsLoading(true);
    }
    else if (item === 'Request New Claim') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      showClaimPopup();
      // Handle the Request New Claim action
    } else if (item === 'Remove Member') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      setEndorseMember(
        state =>
        ({
          ...state,
          scheme_id: cellInfo.data.SchemeID,
          policy_member_id: cellInfo.data.MemberId,
          endorsement_type: '3',
          requested_change: 'Remove Member',
          MemberSalary: cellInfo.data.Salary,
          effective_date: new Date()
        })
      );

      setPopupDialogVisible(true);
      // Handle the Remove Member action
    } else if (item === 'Early Settlement Refund') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      setEndorseMember(
        state =>
        ({
          ...state,
          scheme_id: cellInfo.data.SchemeID,
          policy_member_id: cellInfo.data.MemberId,
          endorsement_type: '8',
          requested_change: 'Paid Off',
          effective_date: new Date(),
          loan_number: cellInfo.data.LoanNumber,
          LoanAmount: cellInfo.data.OriginalLoanAmt,
          category_code: cellInfo.data.CategoryCodeString,
          settlement_date: new Date()
        })
      );

      setPopupPayOffVisible(true);
      // Handle the Remove Member action
    } else if (item === 'Remove Member') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      setEndorseMember(
        state =>
        ({
          ...state,
          scheme_id: cellInfo.data.SchemeID,
          policy_member_id: cellInfo.data.MemberId,
          endorsement_type: '3',
          requested_change: 'Remove Member',
          MemberSalary: cellInfo.data.Salary,
          effective_date: new Date()
        })
      );

      setPopupDialogVisible(true);
      // Handle the Remove Member action
    } else if (item === 'Loan Term Extension') {
      setIsLoanTermExt(true);
      setIsLoanTop(false);

      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);

      setLoanNo(cellInfo.data.Names);
      setCurrentLoanTerm(cellInfo.data.LoanTerm);
      setCurrentLoanAmount(GlobalParams.formatNumberWithCommas(cellInfo.data.OriginalLoanAmt));
      setTenor(cellInfo.data.MemberId);
      setInterestRate(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      let tmpLoanAmount = parseFloat(cellInfo.data.OriginalLoanAmt);
      //LoanBalance
      setLoanTopStore(
        state =>
        ({
          ...state,
          scheme_id: cellInfo.data.SchemeID,
          endorsement_type: '7',
          policy_member_id: cellInfo.data.MemberId,
          portal_user_id: GlobalParams.ContactPersonId,
          requested_change: 'Loan Term Extension',
          is_loan_amount_topup: 0,
          outstanding_loan_amount: cellInfo.data.LoanBalance,
          loan_number: cellInfo.data.LoanNumber,
          premium_rate: 0,
          category_code: cellInfo.data.CategoryCodeString,
          new_loan_tenure: '',
          effective_date: new Date()
        })
      );
      setPopupLoanTopUpVisible(true);
    } else if (item === 'Loan Top up') {
      setIsLoanTermExt(false);
      setIsLoanTop(true);
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);

      setLoanNo(cellInfo.data.Names);
      setCurrentLoanAmount(GlobalParams.formatNumberWithCommas(cellInfo.data.OriginalLoanAmt));
      setTenor(cellInfo.data.MemberId);
      setInterestRate(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      let tmpLoanAmount = parseFloat(cellInfo.data.OriginalLoanAmt);

      setLoanTopStore(
        state =>
        ({
          ...state,
          scheme_id: cellInfo.data.SchemeID,
          endorsement_type: '7',
          portal_user_id: GlobalParams.ContactPersonId,
          policy_member_id: cellInfo.data.MemberId,
          requested_change: 'Loan Top up',
          is_loan_amount_topup: 1,
          new_loan_amount: '',
          loan_number: cellInfo.data.LoanNumber,
          //new_loan_interest_rate: cellInfo.data.InterestRate,
          new_loan_issue_date: new Date(),
          premium_rate: 0,
          category_code: cellInfo.data.CategoryCodeString,
          //new_loan_tenure: null,
          effective_date: new Date(),
          //currentLoanAmount: GlobalParams.formatNumberWithCommas(tmpLoanAmount),
          //policy_member_id: cellInfo.data.MemberId,
          //Salary: GlobalParams.formatNumberWithCommas(cellInfo.data.Salary)
        })
      );
      setPopupLoanTopUpVisible(true);
    } else if (item === 'Adjust Salary') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setPreviousSalary(GlobalParams.formatNumberWithCommas(cellInfo.data.Salary));
      let tmpSalary = 0;
      if (parseFloat(cellInfo.data.Salary) > 0) {
        tmpSalary = parseFloat(cellInfo.data.Salary) / 12;
      }
      setPreviousMonthlySalary(GlobalParams.formatNumberWithCommas(tmpSalary));
      setSchemeID(cellInfo.data.SchemeID);
      setEndorseMember(
        state =>
        ({
          ...state,
          CurrentSalary: GlobalParams.formatNumberWithCommas(tmpSalary),
          scheme_id: cellInfo.data.SchemeID,
          policy_member_id: cellInfo.data.MemberId,
          endorsement_type: '6',
          requested_change: 'Adjust Salary',
          MemberSalary: '',
          effective_date: new Date(),
          Salary: GlobalParams.formatNumberWithCommas(cellInfo.data.Salary)
        })
      );
      setPopupSalaryVisible(true);
      // Handle the Adjust Salary action
    } else if (item === 'Print Cover Certificate') {

      setreport_name('Print Cover Certificate');
      //setPopupReportVisible(true);
      setIsLoading(true);

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=012&referenceNumber=' + cellInfo.data.MemberId + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);
    } else if (item === 'View Dependant(s)') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setPreviousSalary(cellInfo.data.MemberSalary);
      setSchemeID(cellInfo.data.SchemeID);

      //TODO - only display from fetching the members dependants...
      setIsLoading(true);
      fetchDp(cellInfo.data.SchemeID, cellInfo.data.MemberId, cellInfo.data.member_no, 0);
    } else if (item === 'Add Dependant(s)') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setPreviousSalary(cellInfo.data.MemberSalary);
      setSchemeID(cellInfo.data.SchemeID);

      //TODO - only display from fetching the members dependants...
      setIsLoading(true);
      fetchDp(cellInfo.data.SchemeID, cellInfo.data.MemberId, cellInfo.data.member_no, 1);
    } else if (item === 'Medical Requirement Form') {
      //showClaimPopup();
      // Handle the Request New Claim action
      setreport_name('Medical Requirement Form');
      //setPopupReportVisible(true);
      setIsLoading(true);

      //cellInfo.data.MemberId

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=013&referenceNumber=' + cellInfo.data.MemberId + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);

    }
  };

  const onMenuMedItemClick = (cellInfo, item) => {
    if (item === 'Medical Requirement Form') {
      //showClaimPopup();
      // Handle the Request New Claim action
      setreport_name('Medical Requirement Form');
      //setPopupReportVisible(true);
      setIsLoading(true);

      //cellInfo.data.MemberId

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=013&referenceNumber=' + cellInfo.data.MemberId + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);

    }
  };

  const onMenuMedRecItemClick = (cellInfo, item) => {
    if (item === 'Medical Decision Letter') {
      setreport_name('Medical Decision Letter');
      //setPopupReportVisible(true);
      setIsLoading(true);

      //reportType=014&referenceNumber=658&email=flaughters@gmail.com
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=014&referenceNumber=' + cellInfo.data.MemberId + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);
    }
    if (item === 'Medical Cover Letter') {
      setreport_name('Medical Cover Letter');
      //setPopupReportVisible(true);
      setIsLoading(true);

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=012&referenceNumber=' + cellInfo.data.MemberId + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);
    }
    if (item === 'Extra Premium Debit Note') {
      //if(cellInfo.data.med_uw_decision === '3'){
      // console.log('Extra Premium Debit Note');
      setIsLoading(true);
      fetchExtraPremium(cellInfo.data.SchemeID, cellInfo.data.MemberId);
      // }else{
      // notify("No extra premium debit notes found for the client.", 'error', 5000);
      //}
    }
  };

  //{/*onItemClick={(e) => onMenuItemClick(e.itemData.text)}*/}
  const getMenuItems = () => {
    if (isCreditLife) {
      return [
        //{ text: 'Supplimentary', icon: 'add' },
        { text: 'Loan Top up', icon: 'money' },
        { text: 'Loan Term Extension', icon: 'money' },
        { text: 'Early Settlement Refund', icon: 'trash' },
      ];
    } else {
      if (fixed_benefit) {
        return [
          { text: 'Request New Claim', icon: 'edit' },
          { text: 'Remove Member', icon: 'trash' },
          //{ text: 'Adjust Salary', icon: 'money' },
          { text: 'View Dependant(s)', icon: 'group' },
          { text: 'Add Dependant(s)', icon: 'plus' },
          { text: 'Print Cover Certificate', icon: 'doc' },
          //{ text: 'Medical Requirement Form', icon: 'doc' }
        ];
      } else {
        return [
          { text: 'Request New Claim', icon: 'edit' },
          { text: 'Remove Member', icon: 'trash' },
          { text: 'Adjust Salary', icon: 'money' },
          { text: 'View Dependant(s)', icon: 'group' },
          { text: 'Add Dependant(s)', icon: 'plus' },
          { text: 'Print Cover Certificate', icon: 'doc' },
          { text: 'Medical Requirement Form', icon: 'doc' }
        ];
      }
    }
  }

  const menuItems = [
    { text: 'Request New Claim', icon: 'edit' },
    { text: 'Remove Member', icon: 'trash' },
    { text: 'Adjust Salary', icon: 'money' },
    { text: 'View Dependant(s)', icon: 'group' },
    { text: 'Add Dependant(s)', icon: 'plus' },
    { text: 'Print Cover Certificate', icon: 'doc' },
    { text: 'Medical Requirement Form', icon: 'doc' }
  ];//

  const menuMedItems = [
    { text: 'Medical Requirement Form', icon: 'doc' }
  ];

  const menuMedRecItems = [
    { text: 'Medical Decision Letter', icon: 'doc' },
    { text: 'Medical Cover Letter', icon: 'doc' },
    { text: 'Extra Premium Debit Note', icon: 'doc' }
  ];

  const actionMedRecColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuMedRecItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuMedRecItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  const actionMedColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuMedItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuMedItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };
  //vsIsPen 
  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}>
          <Item
            text=" "
            items={(() => {
              let isLoggedIn = (localStorage.getItem('isLoggedIn') === '1');
              // Define the array
              //let menuItems = [{ text: 'Statement of Account', icon: 'doc' }];
              let menuItems = [];
              if (IsPopFund || IsPen) {
                menuItems.push({ text: 'Statement of Account', icon: 'doc' });
              }
              if (IsPopFund) {
                menuItems.push({ text: 'Request New Claim', icon: 'doc' });
              }
              // Conditionally add 'Request New Claim' item
              //if (!isLoggedIn && IsPopFund) {

              //}

              return menuItems;
            })()} // Immediately invoked function to build the items array
          >
          </Item>
        </Menu>
      </div>
    );
  };

  const [popupDialogVisible, setPopupDialogVisible] = React.useState(false);

  const handleOkButtonClick = () => {
    //sendPaymentPrompt(mobile, modalPremium, payMode, name, email, policyNo);
    setPopupDialogVisible(false);
    setIsLoading(true);
    postEndorse(memberStore, 2);
  };

  const handleCancelButtonClick = () => {
    setPopupDialogVisible(false);
  };

  const handleOkPaidOffButtonClick = () => {
    //sendPaymentPrompt(mobile, modalPremium, payMode, name, email, policyNo);
    setPopupPayOffVisible(false);
    setIsLoading(true);
    postEndorse(memberStore, 2);
  };

  const handleCancelPaidOffButtonClick = () => {
    setPopupPayOffVisible(false);
  };

  const [popupSalaryVisible, setPopupSalaryVisible] = React.useState(false);

  const handleOkSalaryButtonClick = () => {
    //sendPaymentPrompt(mobile, modalPremium, payMode, name, email, policyNo);
    setPopupSalaryVisible(false);
  };

  const handleCancelSalaryButtonClick = () => {
    setPopupSalaryVisible(false);
  };

  /////////handle member movement pop up//////////
  const [popupMovementVisible, setPopupMovementVisible] = React.useState(false);

  const handleOkMovementButtonClick = () => {
    setPopupMovementVisible(false);
  };

  const handleCancelMovementButtonClick = () => {
    setPopupMovementVisible(false);
  };
  ///////end of member movement pop up/////////

  //////////handle bulk uploads////////
  const [popupBulkVisible, setPopupBulkVisible] = useState(false);

  const hideBulkPopup = () => {
    setPopupBulkVisible(false);
  };
  /////////end of handle bulk uploads///

  //////handle member medicals pop up//////
  const [popupMedicalsVisible, setPopupMedicalsVisible] = React.useState(false);

  const handleOkMedicalsButtonClick = () => {
    setPopupMedicalsVisible(false);
  };

  const handleCancelMedicalsButtonClick = () => {
    setPopupMedicalsVisible(false);
  };
  /////handle member medicals pop up//////


  //{/*onHiding={hideClaimPopup}*/}
  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };




  const postEndorse = async (post_data, endorseType) => {
    try {
      //originalString.replace(/[,!]/g, ''); 
      if (post_data.MemberSalary !== undefined && post_data.MemberSalary !== null) {
        post_data.MemberSalary = parseFloat(post_data.MemberSalary.replace(/[,!]/g, '')).toFixed(2);
      }

      post_data.portal_user_id = GlobalParams.ContactPersonId;

      let url = "request-endorsements";
      if (isCreditLife) {
        url = "credit-life-endorsement-request";
      }
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + url,
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      //console.log(result.status);
      if (!result.data.success) {
        setIsLoading(false);
        notify(result.data.message, 'error', 5000);
      } else {
        setIsLoading(false);
        notify("Endorsement Request Successfully Submitted", 'success', 5000);
        if (endorseType === 1 || endorseType === '1') {
          //adjust member salary
          setPopupSalaryVisible(false);
        } else if (endorseType === 2 || endorseType === '2') {
          //remove member
          setPopupDialogVisible(false);
        } else if (endorseType === 7 || endorseType === '7') {
          //loan top up / loan term top up
          setPopupLoanTopUpVisible(false);
        } else if (endorseType === 8 || endorseType === '8') {
          //paid off
          setPopupPayOffVisible(false);
        }
      }
      //console.log(result.data.request_id);
      postAutomate(result.data.data.request_id, post_data.scheme_id);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postSchemeBalance = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "recalculate-scheme-balance",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postDebits = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "post-debits-to-gl",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postSchemeBalance(scheme_id);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postAutomate = async (request_id, scheme_id) => {
    try {

      let post_data = {
        'request_id': request_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "get-endorsements-processing-results",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postDebits(scheme_id);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const doLoanTopUp = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);
    postEndorse(loanTopUpStore, 7);
  }, [loanTopUpStore]);

  const doAdjustSalary = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);
    postEndorse(memberStore, 1);
  }, [memberStore]);

  //////report popup//////////
  const fetchRpt = async (data) => {
    try {

      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        JSON.stringify({
          'criteria': data,
        })
      );


      setPopupReportVisible(true);
      // Delay setting isLoading to false until after renderPdfViewer completes
      renderPdfViewer(result);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify("Error Fetching the report", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };
  const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const hideReportButtonClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }
    setPopupReportVisible(false);
  };
  //////end of report popup///

  const [popupDependantsVisible, setPopupDependantsVisible] = useState(false);
  const handleDependantsButtonClick = () => {
    setDependantsData([]);
    setPopupDependantsVisible(false);
  };
  const [dependantsData, setDependantsData] = useState([]);

  const [popupDpVisible, setPopupDpVisible] = useState(false);
  const hideDpPopup = () => {
    setPopupDpVisible(false);
  };

  /// popup change request//
  const [popupChangeRequestsVisible, setPopupChangeRequestsVisible] = useState(false);
  const hideChangeRequestsPopup = () => {
    setPopupChangeRequestsVisible(false);
  }

  const [btnViewMember, setBtnViewMember] = useState('default');

  const [btnSupplimentary, setBtnSupplimentary] = useState('default');
  const [btnLoanTopUp, setBtnLoanTopUp] = useState('default');
  const [btnLoanTermExt, setBtnLoanTermExt] = useState('default');
  const [btnPayOff, setBtnPayOff] = useState('default');

  const [btnAddMember, setBtnAddMember] = useState('default');
  const [btnRemoveMember, setBtnRemoveMember] = useState('default');
  const [btnAdjustMember, setBtnAdjustMember] = useState('default');
  const [btnAddDependant, setBtnAddDependant] = useState('default');
  const [btnBulkServicing, setBtnBulkServicing] = useState('default');
  const [btnChangeRequests, setBtnChangeRequests] = useState('default');
  const [btnMedicalRpt, setBtnMedicalRpt] = useState('default');
  const defaultBtnOptions = () => {
    setBtnViewMember('default');
    setBtnSupplimentary('default');
    setBtnLoanTopUp('default');
    setBtnLoanTermExt('default');
    setBtnPayOff('default');
    setBtnAddMember('default');
    setBtnRemoveMember('default');
    setBtnAdjustMember('default');
    setBtnAddDependant('default');
    setBtnBulkServicing('default');
    setBtnMedicalRpt('default');
    setBtnChangeRequests('default');
  }

  //filter the schemes according to either group Life or Credit Life
  const filterSchemes = (isCreditLifeCover) => {
    var scheme_Store = [];
    //schemeStore
    if (isCreditLifeCover === "1") {
      setLblSearchCriteria('Name / Member No / Loan No');
      setIsCreditLife(true);
    } else {
      setLblSearchCriteria('Name / Staff No');
      if (vsIsPen) {
        setLblSearchCriteria('Staff No');
      }
      setIsCreditLife(false);
    }
    scheme_Store = GlobalParams.schemeStore.filter(item => item.IsCreditLifeCover === isCreditLifeCover);
    if (scheme_Store.length === 1) {
      console.log(scheme_Store[0].schemeID);
      setSearchStore({ ...searchStore, scheme_id: scheme_Store[0].schemeID });
    }
    return scheme_Store;
  }


  return (
    // {isLoading && <LoadPanel visible={true}
    <div>
      <LoadPanel visible={isLoading} />
      <div>

        <Popup
          hideOnOutsideClick={false}
          visible={popupDpVisible}
          onHiding={hideDpPopup}
          title="ADD NEW DEPENDANT"
          position={{ my: 'top', at: 'top', of: window }}
          height={350}
        >
          <MemberDependant onClosePopup={(e) => {
            setDependantsData((prevData) => {
              // Ensure prevData is initialized as an array
              const tmp_dependant = Array.isArray(prevData) ? [...prevData, e] : [e];
              return tmp_dependant;
            });
            hideDpPopup();

          }} SchemeID={schemeID} />
        </Popup>
      </div>


      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupRptSrchVisible}
          title={''}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideRptSrchButtonClick}
        >

          <div>
            <form onSubmit={doFetchRpt}>
              <Form formData={periodStore}>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />
                <Item
                  dataField="AccountYear"
                  editorType="dxLookup"
                  editorOptions={
                    {
                      dataSource: AccountYearStore,
                      displayExpr: "name",
                      valueExpr: "id",
                      searchEnabled: true,
                      onValueChanged: (e) => {
                        setPeriodStore({ ...periodStore, AccountYear: e.value });
                      }
                    }
                  }
                >
                  {true && <RequiredRule message="Year is required" />}
                  <Label text='Year' />
                </Item>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SUBMIT" icon='save' useSubmitBehavior={true} />
                </ButtonItem>

              </Form>
            </form>
          </div>

        </Popup>
      </div>

      {/*Dependants popup*/}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupDependantsVisible}
          title={''}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={true}
          onHiding={handleDependantsButtonClick}
          height={350}
        >
          <div>
            <Button
              visible={vsAddDependants}
              type='danger'
              width={180}
              text="Add Dependant"
              icon='plus'
              onClick={
                () => {
                  setPopupDpVisible(true);
                }
              }
            />
            <br></br><br></br>
            <DataGrid
              visible={true} width={'96%'}
              dataSource={dependantsData} wordWrapEnabled={true} columnHidingEnabled={false}
              searchPanel={searchPanelOptions} editing={dpGridOptions}
              allowColumnReordering={true} scrolling={scrollingOptions} paging={pagingOptions}>
              {/*ID, MemberId, Name, DependantNo, SumAssured, Premium, Relation, Status, IsActive */}
              <Column dataField="isNew" dataType='boolean' visible={vsAddDependants}></Column>
              <Column dataField="DependantNo" visible={false}></Column>
              <Column dataField="DependantFullName" caption='Full Names'></Column>
              <Column
                dataField="DependantDOB"
                caption='Date Of Birth'
                dataType="date">
              </Column>
              <Column
                dataField="RelationshipType"
                caption='Relationship'
                lookup={
                  {
                    dataSource: GlobalParams.RelationshipStore, valueExpr: 'id', displayExpr: 'name'
                  }
                }
              >
              </Column>
              <Column
                dataField="DependantJoiningDate"
                caption='Joining Date'
                dataType="date">
              </Column>
            </DataGrid>
            <br></br>
            <div style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
              <Button
                visible={vsAddDependants}
                type='default'
                horizontalAlignment='right'
                width={180}
                text="SUBMIT"
                icon='save'
                onClick={
                  () => {
                    //handleDependantsButtonClick();
                    setIsLoading(true);
                    postDependants(schemeID, member_id, '7');
                  }
                }
              />
            </div>
          </div>
        </Popup>
      </div>

      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReportVisible}
          title={report_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReportButtonClick}
        >
          <LoadPanel visible={isLoading} />
          <div ref={containerRef} id="pdf-container"></div>
        </Popup>
      </div>
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupSalaryVisible}
          title={'ADJUST SALARY FOR ' + member_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={true}
          onHiding={handleCancelSalaryButtonClick}
          width={500}
          height={400}
        >
          <div>
            <form onSubmit={doAdjustSalary}>
              <Form formData={memberStore}>
                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <Item
                  dataField="CurrentSalary"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      readOnly: true,
                      value: previousMonthlySalary,

                    }
                  }
                >
                  <Label text={'Current Monthly Salary'} />
                </Item>

                <Item
                  dataField="Salary"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      readOnly: true,
                      value: previousSalary
                    }
                  }
                >
                  <Label text={'Current Annual Salary'} />
                </Item>

                <Item
                  dataField="CurrentMemberSalary"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      format: ",##0.###",
                      onValueChanged: (e) => {
                        let member_salo = GlobalParams.formatNumberWithCommas(parseFloat(e.value) * 12);

                        setEndorseMember((state) => {
                          return ({ ...state, MemberSalary: member_salo })
                        });
                      }
                    }
                  }
                >
                  <RequiredRule message="New Monthly Salary is required" />
                  <Label text={'New Monthly Salary'} />
                </Item>

                <Item
                  dataField="MemberSalary"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      // onValueChanged: (e) => {
                      //   let member_salo = e.value;
                      //   setEndorseMember((state) => {
                      //     return ({ ...state, MemberSalary: member_salo })
                      //   });
                      // },
                      readOnly: true
                    }
                  }
                >
                  <RequiredRule message="New Salary is required" />
                  <Label text={'New Annual Salary'} />
                </Item>

                <Item
                  dataField="effective_date"
                  editorType="dxDateBox"
                  editorOptions={
                    {
                      onValueChanged: (e) => {


                        if (e.value !== undefined && e.value !== null && e.value !== '') {
                          //get the cover periods dates

                          const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === memberStore.scheme_id);

                          // Assign the name to the variable 'ans'
                          const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                          const End_date = SchemeDetails ? SchemeDetails.End_date : null;

                          if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value))) {

                            setEndorseMember(state => ({ ...state, effective_date: new Date(e.value) }));
                          } else {
                            // Clear the value if age is not within the range
                            e.component.option('value', null);
                            // You can also provide feedback to the user that the value is invalid
                            notify('Salary Adjustment Date is Outside the cover period', 'error', 5000);
                          }
                        }


                      }
                    }
                  }
                >
                  <RequiredRule message="Effective Date is required" />
                  <Label text={'Effective Date'} />
                </Item>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SUBMIT" icon='save' useSubmitBehavior={true} />
                </ButtonItem>

              </Form>
            </form>
          </div>
        </Popup>
      </div>
      <div>
        <Popup
          visible={popupDialogVisible}
          title={'REMOVE MEMBER'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={true}
          onHiding={handleCancelButtonClick}
          width={300}
          height={210}
        >
          <div>
            <p>{'Are you sure you want to remove ' + member_name + '?'}</p>
            <br></br>
            <Button text="SUBMIT" type='default' onClick={handleOkButtonClick} />
            <Button style={{
              float: 'right',
            }} text="CANCEL" type='danger' onClick={handleCancelButtonClick} />
          </div>
        </Popup>
      </div>
      <div>
        <Popup
          visible={popupVisible}
          onHiding={hidePopup}
          title="ADD NEW MEMBER"
        >
          <NewMember onClosePopup={hidePopup} schemeStore={schemeStore} />
        </Popup>
      </div>

      <div>
        <Popup
          visible={popupBulkVisible}
          onHiding={hideBulkPopup}
          title="BULK MOVEMENTS"
        >
          {/* <UploadMembers onClosePopup={hideBulkPopup} schemeStore={schemeStore} /> */}
        </Popup>
      </div>

      <div>
        <Popup
          visible={popupChangeRequestsVisible}
          onHiding={hideChangeRequestsPopup}
          title="Change Requests"
        >
          {/* <ChangesRequests /> */}
        </Popup>
      </div>

      <div>
        {popupClaimVisible && (
          <Popup
            visible={popupClaimVisible}
            title="REQUEST A NEW CLAIM"
            dragEnabled={true}
            showCloseButton={true}
            hideOnOutsideClick={false}
            onHiding={hideClaimPopup}
          >
            <NewClaim
              onClosePopup={hideClaimPopup}
              MemberName={member_name}
              MemberNumber={member_no}
              MemberId={member_id}
              PolicyNo={schemeID}
              claimId={null}
              IsApproval={0}
            />
          </Popup>
        )}
      </div>


      {/*<div>
        <h2>Members</h2>
          <p>{receivedData}</p>
  </div> formData={searchStore}*/}
      <Popup
        visible={popupMovementVisible}
        title={popUpMemberTitle}
        dragEnabled={true}
        showCloseButton={true}
        hideOnOutsideClick={true}
        onHiding={handleCancelMovementButtonClick}
      >
        <div>
          {popupMovementVisible &&
            <form onSubmit={doSearch}>
              <Form
                formData={searchStore}>
                <GroupItem colCount={1} caption="Member Search">
                  <Item
                    dataField="scheme_id"
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: schemeStore,
                        displayExpr: "PolicyCompany",
                        valueExpr: "schemeID",
                        searchEnabled: false,
                        onValueChanged: (e) => {
                          const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === e.value);
                          if (SchemeDetails.IsCreditLifeCover === "1") {
                            setIsCreditLife(true);
                          } else {
                            if (SchemeDetails.fixed_benefit === "1") {
                              set_fixed_benefit(true);
                            } else {
                              set_fixed_benefit(false);
                            }
                            setIsCreditLife(false);
                          }
                          onProductValueChanged(e);
                        }
                      }
                    }
                  >
                    <RequiredRule message="Scheme is required" />
                    <Label text='Scheme' location="top" />
                  </Item>

                  <Item
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          setSearchStore({ ...searchStore, name: e.value });
                        }
                      }
                    }
                  >
                    <RequiredRule message="Staff No is required" />
                    <Label text={lblSearchCriteria} location="top" />
                  </Item>

                  <ButtonItem
                    horizontalAlignment='right'
                  >
                    <ButtonOptions
                      horizontalAlignment='right'
                      type='default'
                      text="Search"
                      icon='search'
                      useSubmitBehavior={true} />
                  </ButtonItem>
                </GroupItem>
              </Form>
            </form>
          }
        </div>
      </Popup>
      <br></br>
      {/* Search for medicals */}
      <Popup
        visible={popupMedicalsVisible}
        title={'MEDICALS'}
        dragEnabled={true}
        showCloseButton={true}
        hideOnOutsideClick={true}
        onHiding={handleCancelMedicalsButtonClick}
      >
        <div>
          <form onSubmit={doMedicalSearch}>
            <Form
              formData={searchMedicalsStore}>
              <GroupItem colCount={1} caption="Member Search">
                <Item
                  dataField="scheme_id"
                  editorType="dxLookup"
                  editorOptions={
                    {
                      dataSource: schemeStore,
                      displayExpr: "PolicyCompany",
                      valueExpr: "schemeID",
                      searchEnabled: false,
                      onValueChanged: (e) => {
                        const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === e.value);
                        if (SchemeDetails.IsCreditLifeCover === "1") {
                          setIsCreditLife(true);
                        } else {
                          setIsCreditLife(false);
                        }
                        onProductValueChanged(e);
                      }
                    }
                  }
                >
                  <RequiredRule message="Policy No / Scheme is required" />
                  <Label text='Policy No / Scheme' />
                </Item>

                <Item
                  dataField="medical_type"
                  editorType="dxLookup"
                  width={300}
                  editorOptions={
                    {
                      width: 300,
                      dataSource: GlobalParams.MedicalTypes,
                      displayExpr: "name",
                      valueExpr: "id",
                      searchEnabled: false,
                      onValueChanged: (e) => {
                        if (e.value !== undefined && e.value !== null && e.value !== '') {
                          setSearchMedicalStore(state => ({ ...state, medical_type: e.value }));
                        }
                      }
                    }
                  }
                >
                  <RequiredRule message="Medical of Medical is required" />
                  <Label text='Medical Type' />
                </Item>

                <ButtonItem
                  horizontalAlignment='left'
                >
                  <ButtonOptions
                    horizontalAlignment='left'
                    type='default'
                    text="Search"
                    icon='search'
                    useSubmitBehavior={true} />
                </ButtonItem>
              </GroupItem>
            </Form>
          </form>
        </div>
      </Popup>

      {/* Credit Life UI */}
      <div>
        <Popup
          visible={popupSuppVisible}
          onHiding={hideSuppPopup}
          title="Add New Loan"
        >
          <Supplimentary onClosePopup={hideSuppPopup} schemeStore={schemeStore} />
        </Popup>
      </div>

      <div>
        <Popup
          visible={popupPayOffVisible}
          onHiding={hidePayOffPopup}
          title="Early Settlement Refund"
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={true}
          width={300}
          height={210}
        >
          {/* <PayOff onClosePopup={hidePayOffPopup} /> */}
          <div>
            <p>{'Are you sure you want to pay off Loan for: ' + member_name + '?'}</p>
            <br></br>
            <Button text="SUBMIT" type='default' onClick={handleOkPaidOffButtonClick} />
            <Button style={{
              float: 'right',
            }} text="CANCEL" type='danger' onClick={handleCancelPaidOffButtonClick} />
          </div>
        </Popup>
      </div>

      <div>
        <Popup
          visible={popupLoanTopUpVisible}
          onHiding={hideLoanTopUpPopup}
          title=''
          // title={() => {
          //   if (isLoanTermExt) return "Loan Term Extension";
          //   return "Loan Top Up";
          // }}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={true}
          width={500}
          height={400}
        >
          {/* <LoanTopUp onClosePopup={hideLoanTopUpPopup} /> */}
          <div>
            <form onSubmit={doLoanTopUp}>
              <Form formData={loanTopUpStore}>
                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <Item
                  dataField="loan_number"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      readOnly: true,
                      value: loanNo,
                    }
                  }
                >
                  <Label text={'Loan No'} />
                </Item>

                <Item
                  dataField="CurrentLoanTerm"
                  editorType="dxTextBox"
                  visible={isLoanTermExt}
                  editorOptions={
                    {
                      // format: ",##0.###",
                      readOnly: true,
                      value: currentLoanTerm,
                    }
                  }
                >
                  <Label text={'Existing Loan Term'} />
                </Item>

                <Item
                  dataField="CurrentLoanAmount"
                  editorType="dxTextBox"
                  visible={isLoanTop}
                  editorOptions={
                    {
                      // format: ",##0.###",
                      readOnly: true,
                      value: currentLoanAmount,
                    }
                  }
                >
                  <Label text={'Existing Loan Amount'} />
                </Item>

                {/* <Item
                  dataField="tenor"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      readOnly: true,
                      value: tenor,
                    }
                  }
                >
                  <Label text={'Loan Tenor'} />
                </Item> */}


                <Item
                  dataField="effective_date"
                  editorType="dxDateBox"
                  editorOptions={
                    {
                      readOnly: true,
                      onValueChanged: (e) => {
                        if (e.value !== undefined && e.value !== null && e.value !== '') {
                          //get the cover periods dates

                          // const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === memberStore.scheme_id);

                          // // Assign the name to the variable 'ans'
                          // const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                          // const End_date = SchemeDetails ? SchemeDetails.End_date : null;

                          // if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value))) {

                          //   setLoanTopStore(state => ({ ...state, effective_date: new Date(e.value) }));
                          // } else {
                          //   // Clear the value if age is not within the range
                          //   e.component.option('value', null);
                          //   // You can also provide feedback to the user that the value is invalid
                          //   notify('Salary Adjustment Date is Outside the cover period', 'error', 5000);
                          // }
                        }


                      }
                    }
                  }
                >
                  {/* <RequiredRule message="Effective Date is required" /> */}
                  <Label text={'Effective Date'} />
                </Item>

                <Item
                  dataField="new_loan_amount"
                  editorType="dxNumberBox"
                  visible={isLoanTop}
                  editorOptions={
                    {
                      format: ",##0.###",
                      onValueChanged: (e) => {
                        setLoanTopStore((state) => {
                          return ({ ...state, NewLoanAmount: e.value })
                        });
                      }
                    }
                  }
                >
                  <RequiredRule message="New Loan Amount is required" />
                  <Label text={'New Loan Amount'} />
                </Item>

                <Item
                  dataField="new_loan_tenure"
                  editorType="dxNumberBox"
                  visible={isLoanTermExt}
                  editorOptions={
                    {
                      format: ",##0.###",
                      onValueChanged: (e) => {
                        setLoanTopStore((state) => {
                          return ({ ...state, NewLoanTerm: e.value })
                        });
                      }
                    }
                  }
                >
                  <RequiredRule message="New Loan Term is required" />
                  <Label text={'New Loan Term'} />
                </Item>




                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SUBMIT" icon='save' useSubmitBehavior={true} />
                </ButtonItem>

              </Form>
            </form>
          </div>
        </Popup>
      </div>
      {/* End of Credit Life UI */}

      {/* <section className="row"> */}
      {/* the buttons */}
      {/* <div className="col-md-3">
          {isLoading && <LoadPanel visible={true} />}
          <br />
          <h4>General</h4>
          <div>
            <Button
              type={btnViewMember}//'default'
              width={btnsWidth}
              text="View Member"
              onClick={
                () => {
                  setSchemeStore(GlobalParams.schemeStore);
                  defaultBtnOptions();
                  setBtnViewMember('danger');
                  setPopUpMemberTitle('View Member');
                  setVsMemberGrid(true);
                  setPopupMovementVisible(true);
                }
              }
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnBulkServicing}
              width={btnsWidth}
              text="Bulk Servicing"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(GlobalParams.schemeStore);
                    defaultBtnOptions();
                    setBtnBulkServicing('danger');
                    setPopUpMemberTitle('Bulk Servicing');
                    setVsMemberGrid(false);
                    setPopupBulkVisible(true);
                  } else {
                    notify(`You don't have an active scheme to do Bulk Servicing`, 'error', 5000);
                  }
                }
              }
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnChangeRequests}
              width={btnsWidth}
              text="View Change Requests"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(GlobalParams.schemeStore);
                    defaultBtnOptions();
                    setBtnChangeRequests('danger');
                    setPopUpMemberTitle('View Change Requests');
                    setVsMemberGrid(false);
                    setPopupChangeRequestsVisible(true);
                  } else {
                    notify(`You don't have an active scheme to View Change Requests`, 'error', 5000);
                  }
                }
              }
            />
          </div>
          
          {vsCreditLifeBtns && <h4 style={{ paddingTop: '10px' }}>Credit Life</h4>}
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnSupplimentary}
              width={btnsWidth}
              visible={vsCreditLifeBtns}
              text="Add New Loan"
              onClick={() => {
                setSchemeStore(filterSchemes("1"));
                defaultBtnOptions();
                setBtnSupplimentary('danger');
                setPopUpMemberTitle('Add New Loan');
                setPopupSuppVisible(true);
              }}
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnLoanTopUp}
              width={btnsWidth}
              visible={vsCreditLifeBtns}
              text="Loan Top Up"
              onClick={() => {
                setSchemeStore(filterSchemes("1"));
                defaultBtnOptions();
                setBtnLoanTopUp('danger');
                setPopUpMemberTitle('Loan Top Up');
                //setPopupLoanTopUpVisible(true);
                setVsMemberGrid(true);
                setPopupMovementVisible(true);
              }}
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnLoanTermExt}
              width={btnsWidth}
              visible={vsCreditLifeBtns}
              text="Loan Term Extension"
              onClick={() => {
                setSchemeStore(filterSchemes("1"));
                defaultBtnOptions();
                setBtnLoanTermExt('danger');
                setPopUpMemberTitle('Loan Term Extension');
                //setPopupLoanTopUpVisible(true);
                setVsMemberGrid(true);
                setPopupMovementVisible(true);
              }}
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnPayOff}
              width={btnsWidth}
              visible={vsCreditLifeBtns}
              text="Early Settlement Refund"
              onClick={() => {
                setSchemeStore(filterSchemes("1"));
                defaultBtnOptions();
                setBtnPayOff('danger');
                setPopUpMemberTitle('Early Settlement Refund');
                //setPopupPayOffVisible(true);
                setVsMemberGrid(true);
                setPopupMovementVisible(true);
              }}
            />
          </div>
          
          {vsGroupLifeBtns && <h4 style={{ paddingTop: '10px' }}>Group Life</h4>}
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnAddMember}
              width={btnsWidth}
              visible={vsGroupLifeBtns}
              text="Add New Member"
              onClick={showPopup}
            />
          </div>

          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnRemoveMember}
              width={btnsWidth}
              visible={vsGroupLifeBtns}
              text="Remove Member"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(filterSchemes("0"));
                    defaultBtnOptions();
                    setBtnRemoveMember('danger');
                    setPopUpMemberTitle('Remove Member');
                    setVsMemberGrid(true);
                    setPopupMovementVisible(true);
                  } else {
                    notify(`You don't have an active scheme to Remove Member`, 'error', 5000);
                  }
                }
              }
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnAdjustMember}
              width={btnsWidth}
              visible={!fixed_benefit}
              text="Adjust Member Salary"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(filterSchemes("0"));
                    defaultBtnOptions();
                    setBtnAdjustMember('danger');
                    setPopUpMemberTitle('Adjust Member Salary');
                    setVsMemberGrid(true);
                    setPopupMovementVisible(true);
                  } else {
                    notify(`You don't have an active scheme to Adjust Member Salary`, 'error', 5000);
                  }
                }
              }
            />
          </div>
          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnAddDependant}
              width={btnsWidth}
              visible={vsGroupLifeBtns}
              text="Add Dependant"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(filterSchemes("0"));
                    defaultBtnOptions();
                    setBtnAddDependant('danger');
                    setPopUpMemberTitle('Add Dependant');
                    setVsMemberGrid(true);
                    setPopupMovementVisible(true);
                  } else {
                    notify(`You don't have an active scheme to Add Dependant`, 'error', 5000);
                  }
                }
              }
            />
          </div>

          <div style={{ paddingTop: '5px' }}>
            <Button
              type={btnMedicalRpt}
              width={btnsWidth}
              visible={vsGroupLifeBtns}
              text="Medical Compliance Report"
              onClick={
                () => {
                  let tmpSchemeStore = [];
                  if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
                    tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
                  }
                  if (tmpSchemeStore.length > 0) {
                    setSchemeStore(filterSchemes("0"));
                    defaultBtnOptions();
                    setBtnMedicalRpt('danger');
                    setPopUpMemberTitle('Medical Compliance Report');
                    setVsMemberGrid(true);
                    setPopupMedicalsVisible(true);

                  } else {
                    notify(`You don't have an active scheme to View Medical Compliance Report`, 'error', 5000);
                  }
                }
              }
            />
          </div>
        </div> */}
      <br />

      {/* <div className="col-md-9"> visible={vsMemberGrid} vsPOPFundMemberSearch*/}
      <div style={{ width: '100%' }}>

        <div>
          {vsPOPFundMemberSearch &&
            <form onSubmit={doSearch}>
              <Form
                formData={searchStore}>
                <GroupItem colCount={1} caption="Member Search">

                  {/* <Item
                    dataField="scheme_id"
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: GlobalParams.schemeStore,
                        displayExpr: "policy_no",
                        valueExpr: "schemeID",
                        searchEnabled: true,
                        readOnly: false,//rdSchemeId,
                        onValueChanged: (e) => {
                          const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === e.value);
                          if (SchemeDetails.IsCreditLifeCover === "1") {
                            setIsCreditLife(true);
                          } else {
                            if (SchemeDetails.fixed_benefit === "1") {
                              set_fixed_benefit(true);
                            } else {
                              set_fixed_benefit(false);
                            }
                            setIsCreditLife(false);
                          }
                          onProductValueChanged(e);
                        }
                      }
                    }
                  >
                    <RequiredRule message="Scheme is required" />
                    <Label text='Scheme' location="top" />
                  </Item>  */}

                  <Item
                    dataField="policy_no"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        // dataSource: GlobalParams.schemeStore,
                        // displayExpr: "policy_no",
                        // valueExpr: "schemeID",
                        // searchEnabled: true,
                        // readOnly: false,//rdSchemeId, 
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            //const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === e.value);
                            //console.log(GlobalParams.schemeStore);
                            const SchemeDetails = GlobalParams.schemeStore.find(item => item.policy_no === e.value);
                            //console.log(SchemeDetails);
                            if (SchemeDetails !== null && SchemeDetails !== undefined) {
                              if(SchemeDetails.class_code === "10"){
                                console.log("Glico Welfare");
                                setIsGlicoWelfare(true);
                              }else{
                                setIsGlicoWelfare(false);
                              }
                              if (SchemeDetails.IsPopFund === "1" || SchemeDetails.class_code === "5") {
                                
                                setIsPopFund(true);
                              } else {
                                setIsPopFund(false);
                              }
                              if (SchemeDetails.pen === "1") {
                                setIsPen(true);
                              } else {
                                setIsPen(false);
                              }
                              if (SchemeDetails.IsCreditLifeCover === "1") {
                                setIsCreditLife(true);
                              } else {
                                if (SchemeDetails.fixed_benefit === "1") {
                                  set_fixed_benefit(true);
                                } else {
                                  set_fixed_benefit(false);
                                }
                                setIsCreditLife(false);
                              }
                              setSchemeID(SchemeDetails.schemeID);
                              setSearchStore({ ...searchStore, scheme_id: SchemeDetails.schemeID });
                              //onProductValueChanged(e);
                            }
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Scheme is required" />
                    <Label text='Scheme' location="top" />
                  </Item>

                  <Item
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        //mask: 'GPS X00000',
                        //maskRules: { X: /[02-9]/ },
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setSearchStore({ ...searchStore, name: e.value });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Staff No is required" />
                    <Label text={lblSearchCriteria} location="top" />
                  </Item>

                  <ButtonItem
                    horizontalAlignment='right'
                  >
                    <ButtonOptions
                      horizontalAlignment='right'
                      type='default'
                      text="Search"
                      icon='search'
                      useSubmitBehavior={true} />
                  </ButtonItem>
                </GroupItem>
              </Form>
            </form>
          }
        </div>

        <form onSubmit={doSearchAll}>
          <Form onContentReady={validateForm}
            formData={searchStore} colCount={2} visible={vsMainMemberSearch}>
            {/*<GroupItem colCount={3} caption="Search Details">*/}
            <Item
              dataField="scheme_id"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.schemeStore,
                  displayExpr: "PolicyCompany",
                  valueExpr: "schemeID",
                  searchEnabled: true,
                  onValueChanged: { onProductValueChanged }
                }
              }
            >
              <RequiredRule message="Scheme is required" />
              <Label text='Scheme' />
            </Item>

            <Item
              dataField="name"
              editorType="dxTextBox"
              visible={false}
              editorOptions={
                {
                  onValueChanged: { onNameValueChanged },
                  width: 400
                }
              }
            >
              <RequiredRule message="Name is required" />
              <Label text='Name' />
            </Item>

            <ButtonItem horizontalAlignment='left'>
              <ButtonOptions
                horizontalAlignment='left'
                type='default'
                text="Fetch Members"
                icon='search'
                useSubmitBehavior={true} />
            </ButtonItem>

          </Form>
        </form>
        <br></br>
        {/* visible={vsIsPen} */}
        <div style={{ color: 'red', fontWeight: 'bold' }}>{popUpMemberTitle}</div>
        <div style={{ width: '100%' }}>
          <DataGrid keyExpr="member_no" visible={vsMainGridMembers}
            dataSource={membersData} wordWrapEnabled={true} columnHidingEnabled={true}
            searchPanel={searchPanelOptions} grouping={groupOptions}
            allowColumnReordering={false} scrolling={scrollingOptions} paging={pagingOptions}

          >
            <Column dataField="SchemeID" visible={false} />
            <Column dataField="MemberId" visible={false} />
            <Column dataField="Salary" visible={false} />
            <Column width={50} caption="" visible={true} cellRender={actionColumnTemplate} />
            {/* Action column vsMovement  */}
            {/* <Column width={50} caption="" visible={vsMovement} cellRender={actionColumnTemplate} />
            <Column width={50} caption="" visible={vsMedicalsAwaiting} cellRender={actionMedColumnTemplate} />
            <Column width={50} caption="" visible={vsMedicalsReceived} cellRender={actionMedRecColumnTemplate} /> */}
            <Column dataField="Names" ></Column>
            <Column dataField="member_no"></Column>

            <Column dataField="dob" caption='Date of Birth' dataType='date' width={120} visible={false}></Column>

            <Column dataField="LoanNumber" width={100} visible={isCreditLife}></Column>
            <Column dataField="OriginalLoanAmt" cellRender={(cellInfo) => {
              const formattedAmount = parseFloat(cellInfo.data.OriginalLoanAmt).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
              return (
                <span>{formattedAmount}</span>
              );
            }} caption='Loan Amount' width={120} visible={isCreditLife}></Column>

            <Column dataField="total_sa" caption='Sum Assured' cellRender={(cellInfo) => {
              const formattedAmount = parseFloat(cellInfo.data.total_sa).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
              return (
                <span>{formattedAmount}</span>
              );
            }} width={120} visible={false}></Column>
            <Column dataField="TotalPremium" cellRender={(cellInfo) => {
              const formattedAmount = parseFloat(cellInfo.data.TotalPremium).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
              return (
                <span>{formattedAmount}</span>
              );
            }} caption='Premium' width={120} visible={false}></Column>

            <Column dataField="HasDependants"
              dataType="boolean" visible={false} />
            <Column dataField="InterestRate" visible={false} />
            {/* CategoryCodeString categoryID */}
            <Column dataField="categoryID" visible={false} />
            <Column dataField="CategoryCodeString" visible={false} />
            <Column dataField="LoanBalance" visible={false} />
            <Column dataField="LoanTerm" visible={false} />
            <Column dataField="GrossTotalSumAssured" visible={false} />
            <Column dataField="GrossTotalPremium" visible={false} />

            <Column dataField="med_uw_date" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsReceived} width={120} />
            <Column dataField="med_uw_decision" visible={vsMedicalsReceived}
              lookup={
                { dataSource: GlobalParams.MedicalUwDecision, valueExpr: 'ID', displayExpr: 'uw_name' }}
            />
            <Column dataField="medical_results" visible={false} />
            <Column dataField="MedicalRequestDate" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsAwaiting} width={120} />

            <Column dataField="IsMedicalValid" caption='Medicals Validity' visible={vsMedicalsReceived} />
            <Column dataField="MedicalTestDate" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsReceived} />
            <Column
              dataField="DateFrom"
              dataType="date" format="dd/MM/yyyy" visible={false} width={120}>
            </Column>
            <Column
              dataField="DateTo"
              dataType="date" format="dd/MM/yyyy" visible={false} width={120}>
            </Column>
          </DataGrid>
        </div>
      </div>
      {/* </section> */}
    </div>
  );
}

export default Members;
